import React from 'react';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/i18n/i18next';
import { LanguageCode, LocalizationNamespace } from '@/i18n/types';

interface I18nProviderProps {
  locale?: LanguageCode;
  namespace?: LocalizationNamespace;
}

export const I18nProvider: React.FC<React.PropsWithChildren<I18nProviderProps>> = ({ children, namespace = 'default', locale = 'en' }) => {
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    let isMounted = true;

    async function loadTranslations() {
      setIsReady(false);
      await i18n.changeLanguage(locale);
      await i18n.loadNamespaces([namespace]);
      i18n.setDefaultNamespace(namespace);

      if (isMounted) {
        setIsReady(true);
      }
    }

    void loadTranslations();

    return () => {
      isMounted = false;
    };
  }, [locale, namespace]);

  if (!isReady) {
    return null;
  }

  return (
    <I18nextProvider i18n={i18n} defaultNS={namespace}>
      {children}
    </I18nextProvider>
  );
};
